export const PRICE_DROP_FO_CREDIT_BANNER_LABEL = (maxRefund: string) =>
  `Your flight is eligible for price drop protection. If we find savings after you book, you automatically receive a credit up to ${maxRefund}.`;
